import React from 'react';
import { FilePreviewRowLayoutProps } from '../types';
import { SimpleBlock } from 'ui-builder';
import { FilePreview, IconButton, IconType } from 'features/nekst-widgets';

export default function FilePreviewRowWeb(props: FilePreviewRowLayoutProps) {
  return (
    <SimpleBlock>
      <FilePreview
        data={props.document._file}
        small
        withSize={props.withSize}
      />

      <IconButton
        onClick={props.onDelete}
        type={IconType.TRASH_CAN}
        size="small"
      />
    </SimpleBlock>
  );
}
